<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div>
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">

    <div class="card-body padding-all-0px margin-left-0px">
      <div class="modal-body padding-top-0px new-cycle-height2 padding-bottom-0px">
        <div class="row height-100pe">


          <div class="col-md-3 bk-color-light2">
            <div class="row margin-top-10" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
              <div class="col-md-12">
                <div class=" card card-background-transparent card-height">
                  <div class="row margin-top-10" *ngIf="Selfbadge">
                    <div class="col-md-10 text-align-center">
                      <div class="badge badge-new-treatmentcycle">Self</div>
                    </div>

                  </div>
                  <div class="row margin-top-10" *ngIf="DonorEggBadge">
                    <div class="col-md-10 text-align-center">
                      <div class="badge badge-new-treatmentcycle">Donor Egg</div>
                    </div>
                  </div>
                  <div class="row margin-top-10" *ngIf="Surrogatebadge">
                    <div class="col-md-10 text-align-center">
                      <div class="badge badge-new-treatmentcycle">Surrogate</div>
                    </div>
                  </div>
                  <div class="row margin-top-10" *ngIf="DonorEggSurrogatebadge">
                    <div class="col-md-10 text-align-center">
                      <div class="badge badge-new-treatmentcycle">Egg Donor Surrogate</div>
                    </div>
                  </div>
                  <div class="row margin-top-10" *ngIf="Fetbadge">
                    <div class="col-md-10 text-align-center">
                      <div class="badge badge-new-treatmentcycle">Fet</div>
                    </div>
                  </div>
                  <div class="row margin-top-10" *ngIf="Dembadge">
                    <div class="col-md-10 text-align-center">
                      <div class="badge badge-new-treatmentcycle">Dem</div>
                    </div>
                  </div>
                  <div class="row margin-top-10">
                    <div class="col-md-11 text-align-center padding-left-0px">
                      <img class="img-circle-50 margin-left-10px" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">
                      <!--<img  class="img-circle-50 margin-left-10px" *ngIf="!l.PatientImageFile" src="dummy.jpg">-->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center">
                      <label class="margin-bottom-0px color5 font-weight-bold font-size-19px margin-bottom-0px">{{l.DisplayName}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center">
                      <label class="margin-bottom-0px">{{l.FormattedCode}}</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-10 padding-left-0px padding-right-0px text-align-center margin-left-3px">
                      <label class="margin-bottom-0px">
                        <!--32yrs,Female-->
                        {{l.Age}},{{l.Gender}}
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <!--<div class="col-md-3">
                      <label>Phone Number:</label>
                    </div>-->
                    <div class="col-md-11 padding-left-0px padding-right-0px text-align-center margin-left-3px">
                      <label class="margin-bottom-0px">{{l.Telephone1}}</label>
                    </div>
                  </div>

                  <div class="row margin-left-0px margin-right-0px" *ngIf='displayTreatment && displayProtocol '>
                    <div class="col-md-10 padding-right-4px">
                      <div class="card card-background-transparent border-all-1px border-radius-5px">
                        <div class="card-body padding-all-0px margin-left-0px">
                          <div class="row margin-left-0px">
                            <div class="col-md-6 text-align-right">
                              <label class="margin-bottom-0px font-size-12px">Cycle Type</label>
                            </div>:
                            <div class="col-md-5">
                              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
                            </div>
                          </div>
                          <div class="row margin-left-0px">
                            <div class="col-md-6 text-align-right padding-left-6px">
                              <label class="margin-bottom-0px font-size-12px">Treatment</label>
                            </div>:
                            <div class="col-md-5">
                              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>


                </div>
              </div>
            </div>
          </div>


          <div class="col-md-9 padding-right-0px">


            <div class="card height-100pe" *ngIf="SelectionPart">
              <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                <div class="row">
                  <div class="col-md-9 padding-left-0px">
                    <label class="margin-bottom-0px font-size-15px font-weight-bold">New Treatment Cycle - Registration Type</label>
                  </div>
                  <!--<div class="col-md-3 text-align-right">
          <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 1 of 3</label>
        </div>-->
                </div>

              </div>
              <div class="card-body margin-left-0px padding-top-0px">
                <div class="row height-100pe padding-top-10px padding-bottom-20px">
                  <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="ShowSelf()">
                    <div class="padding-all-10px height-100pe background-pay badge-cycle">
                      <div class="center-element" (click)="ShowSelf()">
                        <h4 class="">Self</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="ShowEggDonor()">
                    <div class="padding-all-10px height-100pe background-pay badge-cycle">
                      <div class="center-element" (click)="ShowEggDonor()">
                        <h4 class="">Donor Egg</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 height-50-per padding-bottom-10px nav-link-hand" (click)="Showsurrogate()">
                    <div class="padding-all-10px height-100pe background-pay badge-cycle">
                      <div class="center-element" (click)="Showsurrogate()">
                        <h4 class="">Surrogate</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 height-50-per nav-link-hand" (click)="ShowEggandsurogate()">
                    <div class="padding-all-10px height-100pe background-pay badge-cycle">
                      <div class="center-element left-56pe" (click)="ShowEggandsurogate()">
                        <h4 class="">Donor Egg &amp; Surrogate</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 height-50-per nav-link-hand" (click)="ShowDem()">
                    <div class="padding-all-10px height-100pe background-pay badge-cycle">
                      <div class="center-element" (click)="ShowSelf()">
                        <h4 class="">DEM</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 height-50-per nav-link-hand" (click)="ShowFet()">
                    <div class="padding-all-10px height-100pe background-pay badge-cycle">
                      <div class="center-element" (click)="Showfet()">
                        <h4 class="">FET</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <!--<div class="row ">

        <div class="col-md-4 badge-cycle background-pay">
          <div class="row center-element">
            <div class="" (click)="ShowSelf()">


              <h4 class="">Self</h4>


            </div>
          </div>
        </div>
        <div class="col-md-4 badge-cycle background-pay">
          <div class="row center-element">
            <div class="" (click)="ShowEggDonor()">


              <h4 class="">Egg Donor</h4>


            </div>
          </div>
        </div>
        <div class="col-md-4 badge-cycle background-pay">
          <div class="row center-element">
            <div class="" (click)="Showsurrogate()">


              <h4 class="">Surrogate</h4>


            </div>
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-md-4">
          <div class="row">
            <div class="badge chatbox-new-doc margin-right-10px margin-bottom-10px col-md-4 offset-md-3 badge-cycle " (click)="ShowEggandsurogate()">


              <h4 class="margin-top-10 font-size-16px font-weight-bold  padding-top-30pe padding-bottom-30pe white-space-normal">Egg &amp; Surrogate</h4>


            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="badge chatbox-new-doc margin-right-10px margin-bottom-10px col-md-4 offset-md-3 badge-cycle white-space-normal" (click)="ShowSelf()">


              <h4 class="margin-top-10 font-size-16px font-weight-bold  padding-top-30pe padding-bottom-30pe">DEM</h4>


            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="badge chatbox-new-doc margin-right-10px margin-bottom-10px col-md-4 offset-md-3 badge-cycle white-space-normal" (click)="ShowSelf()">


              <h4 class="margin-top-10 font-size-16px font-weight-bold  padding-top-30pe padding-bottom-30pe">FET</h4>


            </div>
          </div>
        </div>
      </div>-->


              </div>
              <div class="card-footer card-footer-new">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>

                <!--<button class="btn font-size-13px actions-btn-prime float-right margin-right-10px" (click)="DisplayStep2()">Continue</button>-->

              </div>

            </div>



            <form class="form " novalidate="" (ngSubmit)="onSubmitself()" #f="ngForm" *ngIf="Showselfdata">
              <div class="card" *ngIf="index1self">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold">Cycle Details</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 1 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-59px margin-left-0px">

                  <div class="row">


                    <div class="offset-md-1 col-md-5 padding-right-0px">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cycle Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFTT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-5  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span> Start Date </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">

                    <div class="date-form">
                      <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                      <a (click)="d1.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>

                  </div>
                </div>






              </div>
            </div>-->

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4  margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Cycle No</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <!--<input type="number" class="form-control" placeholder="Cycle No"
                           id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                           [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                           name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                           maxlength="100" />
                    <small class="form-text text-danger"
                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>-->
                              <input type="text" class="form-control" placeholder="Cycle No"
                                     id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                                     [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                                     name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                     maxlength="5" />
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>

                              <!--<input type="text" class="form-control" placeholder="Cycle No"
                           id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                           [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                           name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" #Endometrium="ngModel"
                           maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                    <small class="form-text text-danger"
                           *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                    <small class="form-text text-danger"
                           *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>-->


                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-10" hidden>
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Menstrual Cycle</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="MENCY"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-7  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Culture Info System</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFGM"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" required #GradingModel="ngModel">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                    </div>
                    <div class="col-md-6">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-8  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Treatment Protocol</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="TRPRO"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-4  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">
                      <span>*</span>End Date
                    </label>
                  </div>
                </div>
                <div class="row">



                  <div class="col-md-6">
                    <div class="date-form">
                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>
                </div>


              </div>
            </div>-->
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Infertility Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="INFRT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9 padding-right-0px">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                        name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks"
                                        [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks" minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel" required></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>

                            </div>

                          </div>

                        </div>
                      </div>

                    </div>

                  </div>



                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-10px" *ngIf='!isRequesting' [disabled]="RecommendedPackage.errors?.required || addconcerns_text.errors?.required " (click)="DisplayStep2()">Continue</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Back()">Back</button>
                </div>

              </div>
              <div class="card" *ngIf="index2self">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px ">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> LMP</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 2 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                  <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                    <div class="row margin-top-10 ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                        <!--<div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
                </div>
              </div>-->
                        <!--<div class="row">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Egg</label>
                </div>
                <div class="col-md-5">
                  <CodeTypeValue CodeType="IVFEG" id="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"
                                 [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType" SelectedValue=""
                                 name="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"></CodeTypeValue>
                </div>
              </div>-->
                        <!--<div class="row margin-top-5px">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Select Donor</label>
                </div>
                <div class="col-md-5" *ngIf="EggDonarName">

                  <label class="margin-top-7px">{{EggDonarName.DisplayName}}</label>

                </div>
                <div class="col-md-2 padding-left-0px margin-top-5px">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectDonorForEgg()"> <i class="fas fa-ellipsis-h"></i></button>
                </div>

              </div>-->
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                          </div>
                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="LmpEgg" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>


                        </div>

                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                          </div>
                          <div class="col-md-6">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>
                          </div>


                        </div>
                        <!--<div class="row">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recepient</label>
                </div>
                <div class="col-md-5">
                  <CodeTypeValue CodeType="IVFRC" id="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType"
                                 [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType" SelectedValue=""
                                 name="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType">

                  </CodeTypeValue>
                </div>
              </div>-->
                        <!--<div class="row margin-top-5px">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Select Donor</label>
                </div>
                <div class="col-md-5">

                  <label class="margin-top-7px">Donor Name</label>

                </div>
                <div class="col-md-2 padding-left-0px margin-top-5px">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectDonorForReceipt()"> <i class="fas fa-ellipsis-h"></i></button>
                </div>

              </div>
              <div class="row margin-top-5px">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                </div>
                <div class="col-md-5">
                  <div class="date-form">
                    <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                           name="dp1" [(ngModel)]="LmpRecepient" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth1="ngModel" required>
                    <small class="form-text text-danger"
                           *ngIf="(!DateOfBirth1.valid && (DateOfBirth1.dirty || DateOfBirth1.touched) && DateOfBirth1.errors.required)">(Field cannot be left blank)</small>

                    <a (click)="d1.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>


              </div>

              <div class="row margin-top-5px">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                </div>
                <div class="col-md-6">
                  <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                            name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                            [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                            #addconcerns_text1="ngModel"></textarea>
                  <small class="form-text text-danger"
                         *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>
                </div>


              </div>-->

                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displaystep3()" *ngIf='!isRequesting' [disabled]="DateOfBirth.errors?.required || addconcerns_text.errors?.required ">Continue</button>

                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displaystep1()">Back</button>
                </div>

              </div>

              <div class="card" *ngIf="index3self">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle -</label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> Schedule</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 3 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-26pe  margin-left-0px padding-top-0px">




                  <div class="col-md-12">

                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Branch  :</label>
                </div>


                <div class="col-md-5">
                  <label class="margin-bottom-0px">{{BranchName}}</label>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Choose Treatment Plan</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="CNSPN"
                                 id="CurrentSaveCounsellingPlanRequest.TreatmentPlan"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.TreatmentPlan" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.TreatmentPlan" required>

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="ProtocolStartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" [(ngModel)]="ProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirthEnd="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirthEnd.valid && (DateOfBirthEnd.dirty || DateOfBirthEnd.touched) && DateOfBirthEnd.errors.required)">(Field cannot be left blank)</small>
                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Recommended Package"
                         id="CurrentSaveCounsellingPlanRequest.RecommendedPackage"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.RecommendedPackage" required
                         name="CurrentSaveCounsellingPlanRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                  <small class="form-text text-danger"
                         *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row  ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Primary Doctor</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Counselling Doctor"
                         id="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         name="CurrentSaveCounsellingPlanRequest.CounsellingDoctor" #Doctor="ngModel"
                         maxlength="100" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Estimated Package Cost</label>
                </div>

                <div class="col-md-5">
                  <input type="number" class="form-control" placeholder="Package Cost"
                         id="CurrentSaveCounsellingPlanRequest.PackageCost"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.PackageCost"
                         name="CurrentSaveCounsellingPlanRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>


                </div>

              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-top-7px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                </div>

                <div class="col-md-5">
                  <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="FNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.FinancialStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.FinancialStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.FinancialStatus">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="PTNT"
                                 id="CurrentSaveCounsellingPlanRequest.Potential"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.Potential" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.Potential">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="PNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.PlanStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.PlanStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.PlanStatus">

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                          </div>

                          <div class="col-md-6 padding-right-0px">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn font-size-13px actions-btn-prime margin-right-5px float-right">Save</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Display3()">Back</button>
                </div>

              </div>
            </form>


            <!--<form class="form " novalidate="" (ngSubmit)="onSubmitEggDonor()" #f="ngForm" *ngIf="ShowEggDonorData">-->

            <form class="form " novalidate="" (ngSubmit)="onSubmitEggDonor()" #f="ngForm" *ngIf="ShowEggDonorData">
              <div class="card" *ngIf="index1EggDonorData">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold">Cycle Details</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 1 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-59px margin-left-0px">

                  <div class="row">


                    <div class="offset-md-1 col-md-5 padding-right-0px">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cycle Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFTT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-5  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span> Start Date </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">

                    <div class="date-form">
                      <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                      <a (click)="d1.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>

                  </div>
                </div>






              </div>
            </div>-->

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4  margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Cycle No</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <!--<input type="number" class="form-control" placeholder="Cycle No"
                           id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                           [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                           name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                           maxlength="100" />
                    <small class="form-text text-danger"
                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>-->
                              <input type="text" class="form-control" placeholder="Cycle No"
                                     id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                                     [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                                     name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                     maxlength="5" />
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>


                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Menstrual Cycle</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="MENCY"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-7  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Culture Info System</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFGM"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" required #GradingModel="ngModel">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-8  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Treatment Protocol</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="TRPRO"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-4  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">
                      <span>*</span>End Date
                    </label>
                  </div>
                </div>
                <div class="row">



                  <div class="col-md-6">
                    <div class="date-form">
                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>
                </div>


              </div>
            </div>-->
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Infertility Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="INFRT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9 padding-right-0px">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                        name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks"
                                        [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                            </div>

                          </div>

                        </div>
                      </div>

                    </div>

                  </div>



                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-10px" [disabled]="RecommendedPackage.errors?.required || addconcerns_text.errors?.required " (click)="DisplayEggDonor1()">Continue</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Back2()">Back</button>
                </div>

              </div>
              <div class="card" *ngIf="index2EggDonorData">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px ">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> LMP</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 2 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                  <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                    <div class="row margin-top-10 ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                        <!--<div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
                </div>
              </div>-->
                        <!--<div class="row">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Egg</label>
                </div>
                <div class="col-md-5">
                  <CodeTypeValue CodeType="IVFEG" id="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"
                                 [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType" SelectedValue=""
                                 name="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"></CodeTypeValue>
                </div>
              </div>-->
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Select Donor</label>
                          </div>
                          <div class="col-md-5">
                            <!--<input type="text" class="form-control" placeholder="Recommended Package">-->
                            <label class="margin-top-7px" *ngIf="patientName">{{patientName}}</label>

                          </div>
                          <div class="col-md-2 padding-left-0px margin-top-5px">
                            <!--<div class="thick-circle4 nav-link-hand">
                    <a>
                      <i class="fas fa-ellipsis-h"></i>
                    </a>
                  </div>-->
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectDonorForEgg()"> <i class="fas fa-ellipsis-h"></i></button>
                          </div>

                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                          </div>
                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="LmpEgg" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>


                        </div>

                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                          </div>
                          <div class="col-md-6">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>
                          </div>


                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" [disabled]="DateOfBirth.errors?.required || addconcerns_text.errors?.required " (click)="DisplayEggDonor2()">Continue</button>

                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="DisplayEggDonorstep1()">Back</button>
                </div>

              </div>

              <div class="card" *ngIf="index3EggDonorData">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle -</label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> Schedule</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 3 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-26pe  margin-left-0px padding-top-0px">




                  <div class="col-md-12">

                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Branch  :</label>
                </div>


                <div class="col-md-5">
                  <label class="margin-bottom-0px">{{BranchName}}</label>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Choose Treatment Plan</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="CNSPN"
                                 id="CurrentSaveCounsellingPlanRequest.TreatmentPlan"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.TreatmentPlan" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.TreatmentPlan" required>

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="ProtocolStartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" [(ngModel)]="ProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Recommended Package"
                         id="CurrentSaveCounsellingPlanRequest.RecommendedPackage"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.RecommendedPackage" required
                         name="CurrentSaveCounsellingPlanRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                  <small class="form-text text-danger"
                         *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row  ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Primary Doctor</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Counselling Doctor"
                         id="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         name="CurrentSaveCounsellingPlanRequest.CounsellingDoctor" #Doctor="ngModel"
                         maxlength="100" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Estimated Package Cost</label>
                </div>

                <div class="col-md-5">
                  <input type="number" class="form-control" placeholder="Package Cost"
                         id="CurrentSaveCounsellingPlanRequest.PackageCost"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.PackageCost"
                         name="CurrentSaveCounsellingPlanRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>


                </div>

              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-top-7px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                </div>

                <div class="col-md-5">
                  <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="FNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.FinancialStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.FinancialStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.FinancialStatus">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="PTNT"
                                 id="CurrentSaveCounsellingPlanRequest.Potential"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.Potential" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.Potential">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="PNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.PlanStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.PlanStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.PlanStatus">

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                          </div>

                          <div class="col-md-6 padding-right-0px">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-5px float-right" [disabled]="!f.valid">Save</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="DisplayEggDonorstep3()">Back</button>
                </div>

              </div>
            </form>

            <!--New for Egg donor yet to complete-->

            <!--<form class="form " novalidate="" #f="ngForm" *ngIf="ShowEggDonorData">
              <div class="card" *ngIf="index1EggDonorData">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold">Cycle Details</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 1 of 2</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-59px margin-left-0px">

                  <div class="row">


                    <div class="offset-md-1 col-md-5 padding-right-0px">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cycle Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFTT"
                                             id="DonorCycleType"
                                             [(ngModel)]="DonorCycleType" SelectedValue=""
                                             name="DonorCycleType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4  margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Cycle No</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <input type="text" class="form-control" placeholder="Cycle No"
                                     id="DonorCycleNo"
                                     [(ngModel)]="DonorCycleNo" required
                                     name="DonorCycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                     maxlength="5" />
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>


                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-10" hidden>
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Menstrual Cycle</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="MENCY"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-7  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Culture Info System</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFGM"
                                             id="DonorGradingModel"
                                             [(ngModel)]="DonorGradingModel" SelectedValue=""
                                             name="DonorGradingModel" required #GradingModel="ngModel">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-8  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Treatment Protocol</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="TRPRO"
                                             id="DonorTreatmentProtocolName"
                                             [(ngModel)]="DonorTreatmentProtocolName" SelectedValue=""
                                             name="DonorTreatmentProtocolName">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Infertility Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="INFRT"
                                             id="DonorInfertilityType"
                                             [(ngModel)]="DonorInfertilityType" SelectedValue=""
                                             name="DonorInfertilityType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9 padding-right-0px">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                        name="DonorConcerns"
                                        [(ngModel)]="DonorConcerns" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 ">

                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9 padding-right-0px">

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>



                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-10px" [disabled]="RecommendedPackage.errors?.required || addconcerns_text.errors?.required " (click)="DisplayEggDonor1()">Continue</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Back2()">Back</button>
                </div>

              </div>

              <div class="card" *ngIf="index2EggDonorData">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px ">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> LMP</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 2 of 2</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                  <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                    <div class="row margin-top-10 ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Select Donor</label>
                          </div>
                          <div class="col-md-5">
                            <label class="margin-top-7px" *ngIf="DonorName">{{DonorName}}({{DonorActorCode}})</label>
                          </div>
                          <div class="col-md-2 padding-left-0px margin-top-5px">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3"
                                    (click)="SelectDonor()">
                              <i class="fas fa-ellipsis-h"></i>
                            </button>
                          </div>

                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Select Donor Episode</label>
                          </div>
                          <div class="col-md-5">
                            <label class="margin-top-7px" *ngIf="DonorEpisode">{{DonorEpisode}}</label>
                          </div>
                          <div class="col-md-2 padding-left-0px margin-top-5px">
                            <button type="button"
                                    class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3"
                                    (click)="SelectDonorEpisode()">
                              <i class="fas fa-ellipsis-h"></i>
                            </button>
                          </div>

                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                          </div>
                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dplmp" [(ngModel)]="LmpEgg" ngbDatepicker #dlmp="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="dlmp.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>


                        </div>
                        <div class="row margin-top-10">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                              </div>


                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp" [(ngModel)]="ProtocolStartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                                  <a (click)="d.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>

                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-md-4 text-align-right margin-tg-auto ">
                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                              </div>


                              <div class="col-md-5">
                                <div class="date-form">
                                  <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                         name="dp1" [(ngModel)]="ProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                  <a (click)="d1.toggle()" class="nav-link-hand">
                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                  </a>

                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                          </div>
                          <div class="col-md-6">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                      name="Remarks"
                                      [(ngModel)]="Remarks" minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                          </div>


                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">
                  <button type="button"
                          class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right"
                          (click)="activeModal.close('Close click')">
                    Cancel
                  </button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px"
                          [disabled]="DateOfBirth.errors?.required || addconcerns_text.errors?.required " (click)="SaveEpisode()">
                    Save
                  </button>

                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="DisplayEggDonorstep1()">Back</button>
                </div>

              </div>

            </form>-->


            <form class="form " novalidate="" (ngSubmit)="onSubmitReceiptDonor()" #f="ngForm" *ngIf="ShowsurrogateData">
              <div class="card" *ngIf="index1surrogateData">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold">Cycle Details</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 1 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-59px margin-left-0px">

                  <div class="row">


                    <div class="offset-md-1 col-md-5 padding-right-0px">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cycle Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFTT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-5  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span> Start Date </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">

                    <div class="date-form">
                      <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                      <a (click)="d1.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>

                  </div>
                </div>






              </div>
            </div>-->

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4  margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Cycle No</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <!--<input type="number" class="form-control" placeholder="Cycle No"
                           id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                           [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                           name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                           maxlength="100" />
                    <small class="form-text text-danger"
                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>-->
                              <input type="text" class="form-control" placeholder="Cycle No"
                                     id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                                     [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                                     name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                     maxlength="5" />
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-10" hidden>
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Menstrual Cycle</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="MENCY"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-7  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Culture Info System</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFGM"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" #GradingModel="ngModel" required>
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                    </div>
                    <div class="col-md-6">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-8  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Treatment Protocol</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="TRPRO"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-4  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">
                      <span>*</span>End Date
                    </label>
                  </div>
                </div>
                <div class="row">



                  <div class="col-md-6">
                    <div class="date-form">
                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>
                </div>


              </div>
            </div>-->
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Infertility Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="INFRT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9 padding-right-0px">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                        name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks"
                                        [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                            </div>

                          </div>

                        </div>
                      </div>

                    </div>

                  </div>



                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-10px" [disabled]="RecommendedPackage.errors?.required || addconcerns_text.errors?.required " (click)="Displaysurrogate2()">Continue</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Back3()">Back</button>
                </div>

              </div>
              <div class="card" *ngIf="index2surrogateData">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px ">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> LMP</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 2 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                  <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                    <div class="row margin-top-10 ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                        <!--<div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
                </div>
              </div>-->
                        <!--<div class="row">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recepient</label>
                </div>
                <div class="col-md-5">
                  <CodeTypeValue CodeType="IVFRC" id="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType"
                                 [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType" SelectedValue=""
                                 name="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType">

                  </CodeTypeValue>
                </div>
              </div>-->
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Select Donor</label>
                          </div>
                          <div class="col-md-5">
                            <!--<input type="text" class="form-control" placeholder="Recommended Package">-->
                            <label class="margin-top-7px" *ngIf="patientNamere">{{patientNamere}}</label>

                          </div>
                          <div class="col-md-2 padding-left-0px margin-top-5px">
                            <!--<div class="thick-circle4 nav-link-hand">
                    <a>
                      <i class="fas fa-ellipsis-h"></i>
                    </a>
                  </div>-->
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectDonorForReceipt()"> <i class="fas fa-ellipsis-h"></i></button>
                          </div>

                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                          </div>
                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" [(ngModel)]="LmpRecepient" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth1="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth1.valid && (DateOfBirth1.dirty || DateOfBirth1.touched) && DateOfBirth1.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>


                        </div>

                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                          </div>
                          <div class="col-md-6">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                                      #addconcerns_text1="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))"></small>
                          </div>


                        </div>

                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" [disabled]="DateOfBirth1.errors?.required || addconcerns_text1.errors?.required " (click)="Displaysurroagte3()">Continue</button>

                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displaysurroagteback()">Back</button>
                </div>

              </div>

              <div class="card" *ngIf="index3surrogateData">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle -</label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> Schedule</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 3 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-26pe  margin-left-0px padding-top-0px">




                  <div class="col-md-12">

                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Branch  :</label>
                </div>


                <div class="col-md-5">
                  <label class="margin-bottom-0px">{{BranchName}}</label>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Choose Treatment Plan</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="CNSPN"
                                 id="CurrentSaveCounsellingPlanRequest.TreatmentPlan"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.TreatmentPlan" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.TreatmentPlan" required>

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="ProtocolStartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" [(ngModel)]="ProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Recommended Package"
                         id="CurrentSaveCounsellingPlanRequest.RecommendedPackage"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.RecommendedPackage" required
                         name="CurrentSaveCounsellingPlanRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                  <small class="form-text text-danger"
                         *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row  ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Primary Doctor</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Counselling Doctor"
                         id="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         name="CurrentSaveCounsellingPlanRequest.CounsellingDoctor" #Doctor="ngModel"
                         maxlength="100" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Estimated Package Cost</label>
                </div>

                <div class="col-md-5">
                  <input type="number" class="form-control" placeholder="Package Cost"
                         id="CurrentSaveCounsellingPlanRequest.PackageCost"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.PackageCost"
                         name="CurrentSaveCounsellingPlanRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>


                </div>

              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-top-7px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                </div>

                <div class="col-md-5">
                  <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="FNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.FinancialStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.FinancialStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.FinancialStatus">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="PTNT"
                                 id="CurrentSaveCounsellingPlanRequest.Potential"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.Potential" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.Potential">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="PNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.PlanStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.PlanStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.PlanStatus">

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                          </div>

                          <div class="col-md-6 padding-right-0px">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-5px float-right" [disabled]="!f.valid">Save</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displaysurogatestep2()">Back</button>
                </div>

              </div>
            </form>


            <form class="form " novalidate="" (ngSubmit)="onSubmit2()" #f="ngForm" *ngIf="eggdonorsurrogate">
              <div class="card" *ngIf="index1eggdonorsurrogate">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold">Cycle Details</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 1 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-59px margin-left-0px">

                  <div class="row">


                    <div class="offset-md-1 col-md-5 padding-right-0px">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cycle Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFTT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-5  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span> Start Date </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">

                    <div class="date-form">
                      <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                      <a (click)="d1.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>

                  </div>
                </div>






              </div>
            </div>-->

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4  margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Cycle No</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <!--<input type="number" class="form-control" placeholder="Cycle No"
                           id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                           [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                           name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                           maxlength="100" />
                    <small class="form-text text-danger"
                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>-->
                              <input type="text" class="form-control" placeholder="Cycle No"
                                     id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                                     [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                                     name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                     maxlength="5" />
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-10" hidden>
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Menstrual Cycle</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="MENCY"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-7  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Culture Info System</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFGM"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel"
                                             #GradingModel="ngModel" required>
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>


                    </div>
                    <div class="col-md-6">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-8  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Treatment Protocol</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="TRPRO"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-4  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">
                      <span>*</span>End Date
                    </label>
                  </div>
                </div>
                <div class="row">



                  <div class="col-md-6">
                    <div class="date-form">
                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>
                </div>


              </div>
            </div>-->
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Infertility Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="INFRT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9 padding-right-0px">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                        name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks"
                                        [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                            </div>

                          </div>

                        </div>
                      </div>

                    </div>

                  </div>



                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-10px" [disabled]="RecommendedPackage.errors?.required || addconcerns_text.errors?.required " (click)="Displayeggsurgatestep2()">Continue</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Back5()">Back</button>
                </div>

              </div>
              <div class="card" *ngIf="index2eggdonorsurrogate">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px ">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> LMP</label>

                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 2 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                  <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                    <div class="row margin-top-10 ">
                      <div class="col-md-6">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                          <!--<div class="row">
                  <div class="col-md-4 text-align-right ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
                  </div>:
                  <div class="col-md-5">
                    <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 text-align-right ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
                  </div>:
                  <div class="col-md-5">
                    <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
                  </div>
                </div>-->
                          <!--<div class="row">
                  <div class="col-md-4 text-align-right margin-top-4px">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Egg</label>
                  </div>
                  <div class="col-md-5">
                    <CodeTypeValue CodeType="IVFEG" id="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"
                                   [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType" SelectedValue=""
                                   name="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"></CodeTypeValue>
                  </div>
                </div>-->
                          <div class="row margin-top-5px">
                            <div class="col-md-6  margin-top-4px">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"> Donor Egg </label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-7">
                              <!--<input type="text" class="form-control" placeholder="Recommended Package">-->
                              <label class="margin-top-7px" *ngIf="patientName">{{patientName}}</label>

                            </div>
                            <div class="col-md-2 padding-left-0px margin-top-5px">
                              <!--<div class="thick-circle4 nav-link-hand">
                      <a>
                        <i class="fas fa-ellipsis-h"></i>
                      </a>
                    </div>-->
                              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectDonorForEgg()"> <i class="fas fa-ellipsis-h"></i></button>
                            </div>

                          </div>
                          <div class="row margin-top-10">
                            <div class="col-md-6  margin-top-4px">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <div class="date-form">
                                <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                       name="dp" [(ngModel)]="LmpEgg" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                                <small class="form-text text-danger"
                                       *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                                <a (click)="d.toggle()" class="nav-link-hand">
                                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                </a>

                              </div>
                            </div>


                          </div>

                          <div class="row margin-top-10">
                            <div class="col-md-6  margin-top-4px">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                        name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                                        [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>
                            </div>


                          </div>

                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">



                          <div class="row margin-top-5px">
                            <div class="col-md-6  margin-top-4px">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Donor Surrogate </label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-7">
                              <!--<input type="text" class="form-control" placeholder="Recommended Package">-->
                              <label class="margin-top-7px" *ngIf="patientNamere">{{patientNamere}}</label>

                            </div>
                            <div class="col-md-2 padding-left-0px margin-top-5px">
                              <!--<div class="thick-circle4 nav-link-hand">
                      <a>
                        <i class="fas fa-ellipsis-h"></i>
                      </a>
                    </div>-->
                              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectDonorForReceipt()"> <i class="fas fa-ellipsis-h"></i></button>
                            </div>

                          </div>
                          <div class="row margin-top-10">
                            <div class="col-md-6  margin-top-4px">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9">
                              <div class="date-form">
                                <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                       name="dp1" [(ngModel)]="LmpRecepient" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth1="ngModel" required>
                                <small class="form-text text-danger"
                                       *ngIf="(!DateOfBirth1.valid && (DateOfBirth1.dirty || DateOfBirth1.touched) && DateOfBirth1.errors.required)">(Field cannot be left blank)</small>

                                <a (click)="d1.toggle()" class="nav-link-hand">
                                  <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                </a>

                              </div>
                            </div>


                          </div>

                          <div class="row margin-top-10">
                            <div class="col-md-6  margin-top-4px">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                        name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                                        [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                                        #addconcerns_text1="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))"></small>
                            </div>


                          </div>

                        </div>
                      </div>

                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displayeggsurrogatestep3()" [disabled]="DateOfBirth1.errors?.required || addconcerns_text1.errors?.required ||addconcerns_text.errors?.required ||DateOfBirth.errors?.required ">Continue</button>

                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displaystep2back()">Back</button>
                </div>

              </div>

              <div class="card" *ngIf="index3eggdonorsurrogate">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle -</label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> Schedule</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 3 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-26pe  margin-left-0px padding-top-0px">




                  <div class="col-md-12">

                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Branch  :</label>
                </div>


                <div class="col-md-5">
                  <label class="margin-bottom-0px">{{BranchName}}</label>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Choose Treatment Plan</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="CNSPN"
                                 id="CurrentSaveCounsellingPlanRequest.TreatmentPlan"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.TreatmentPlan" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.TreatmentPlan" required>

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="ProtocolStartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" [(ngModel)]="ProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Recommended Package"
                         id="CurrentSaveCounsellingPlanRequest.RecommendedPackage"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.RecommendedPackage" required
                         name="CurrentSaveCounsellingPlanRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                  <small class="form-text text-danger"
                         *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row  ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Primary Doctor</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Counselling Doctor"
                         id="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         name="CurrentSaveCounsellingPlanRequest.CounsellingDoctor" #Doctor="ngModel"
                         maxlength="100" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Estimated Package Cost</label>
                </div>

                <div class="col-md-5">
                  <input type="number" class="form-control" placeholder="Package Cost"
                         id="CurrentSaveCounsellingPlanRequest.PackageCost"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.PackageCost"
                         name="CurrentSaveCounsellingPlanRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>


                </div>

              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-top-7px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                </div>

                <div class="col-md-5">
                  <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="FNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.FinancialStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.FinancialStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.FinancialStatus">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="PTNT"
                                 id="CurrentSaveCounsellingPlanRequest.Potential"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.Potential" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.Potential">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="PNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.PlanStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.PlanStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.PlanStatus">

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                          </div>

                          <div class="col-md-6 padding-right-0px">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-5px float-right" [disabled]="!f.valid">Save</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displayeggsurrogatestep2back()">Back</button>
                </div>

              </div>
            </form>

            <form class="form " novalidate="" (ngSubmit)="onSubmitfet()" #f="ngForm" *ngIf="ShowFetdata">
              <div class="card" *ngIf="index1fet">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold">Cycle Details</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 1 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-59px margin-left-0px">

                  <div class="row">


                    <div class="offset-md-1 col-md-5 padding-right-0px">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cycle Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFTT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-5  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span> Start Date </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">

                    <div class="date-form">
                      <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                      <a (click)="d1.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>

                  </div>
                </div>






              </div>
            </div>-->

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4  margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Cycle No</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <!--<input type="number" class="form-control" placeholder="Cycle No"
                           id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                           [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                           name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                           maxlength="100" />
                    <small class="form-text text-danger"
                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>-->
                              <input type="text" class="form-control" placeholder="Cycle No"
                                     id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                                     [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                                     name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                     maxlength="5" />
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>


                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-10" hidden>
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Menstrual Cycle</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="MENCY"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-7  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Culture Info System</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFGM"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" #GradingModel="ngModel" required>
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                    </div>
                    <div class="col-md-6">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-8  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Treatment Protocol</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="FETPR"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-4  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">
                      <span>*</span>End Date
                    </label>
                  </div>
                </div>
                <div class="row">



                  <div class="col-md-6">
                    <div class="date-form">
                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>
                </div>


              </div>
            </div>-->
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Infertility Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="INFRT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9 padding-right-0px">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                        name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks"
                                        [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                            </div>

                          </div>

                        </div>
                      </div>

                    </div>

                  </div>



                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-10px" (click)="Displaystep2fet()" [disabled]="RecommendedPackage.errors?.required || addconcerns_text.errors?.required ">Continue</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="FetBack()">Back</button>
                </div>

              </div>
              <div class="card" *ngIf="index2fet">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px ">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> LMP</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 2 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                  <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                    <div class="row margin-top-10 ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                        <!--<div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
                </div>
              </div>-->
                        <!--<div class="row">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Egg</label>
                </div>
                <div class="col-md-5">
                  <CodeTypeValue CodeType="IVFEG" id="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"
                                 [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType" SelectedValue=""
                                 name="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"></CodeTypeValue>
                </div>
              </div>-->
                        <!--<div class="row margin-top-5px">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Select Donor</label>
                </div>
                <div class="col-md-5" *ngIf="EggDonarName">

                  <label class="margin-top-7px">{{EggDonarName.DisplayName}}</label>

                </div>
                <div class="col-md-2 padding-left-0px margin-top-5px">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectDonorForEgg()"> <i class="fas fa-ellipsis-h"></i></button>
                </div>

              </div>-->
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                          </div>
                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="LmpEgg" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>


                        </div>

                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                          </div>
                          <div class="col-md-6">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>
                          </div>


                        </div>
                        <!--<div class="row">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recepient</label>
                </div>
                <div class="col-md-5">
                  <CodeTypeValue CodeType="IVFRC" id="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType"
                                 [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType" SelectedValue=""
                                 name="CurrentSaveIvfTreatmentCyclesInfoRequest.RecepientType">

                  </CodeTypeValue>
                </div>
              </div>-->
                        <!--<div class="row margin-top-5px">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Select Donor</label>
                </div>
                <div class="col-md-5">

                  <label class="margin-top-7px">Donor Name</label>

                </div>
                <div class="col-md-2 padding-left-0px margin-top-5px">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3  " (click)="SelectDonorForReceipt()"> <i class="fas fa-ellipsis-h"></i></button>
                </div>

              </div>
              <div class="row margin-top-5px">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                </div>
                <div class="col-md-5">
                  <div class="date-form">
                    <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                           name="dp1" [(ngModel)]="LmpRecepient" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth1="ngModel" required>
                    <small class="form-text text-danger"
                           *ngIf="(!DateOfBirth1.valid && (DateOfBirth1.dirty || DateOfBirth1.touched) && DateOfBirth1.errors.required)">(Field cannot be left blank)</small>

                    <a (click)="d1.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>
                </div>


              </div>

              <div class="row margin-top-5px">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                </div>
                <div class="col-md-6">
                  <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                            name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                            [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                            #addconcerns_text1="ngModel"></textarea>
                  <small class="form-text text-danger"
                         *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>
                </div>


              </div>-->

                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displayfetstep3()" [disabled]="DateOfBirth.errors?.required || addconcerns_text.errors?.required ">Continue</button>

                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displayfetstep1()">Back</button>
                </div>

              </div>

              <div class="card" *ngIf="index3fet">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle -</label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> Schedule</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 3 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-26pe  margin-left-0px padding-top-0px">




                  <div class="col-md-12">

                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Branch  :</label>
                </div>


                <div class="col-md-5">
                  <label class="margin-bottom-0px">{{BranchName}}</label>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Choose Treatment Plan</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="CNSPN"
                                 id="CurrentSaveCounsellingPlanRequest.TreatmentPlan"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.TreatmentPlan" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.TreatmentPlan" required>

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="ProtocolStartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" [(ngModel)]="ProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Recommended Package"
                         id="CurrentSaveCounsellingPlanRequest.RecommendedPackage"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.RecommendedPackage" required
                         name="CurrentSaveCounsellingPlanRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                  <small class="form-text text-danger"
                         *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row  ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Primary Doctor</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Counselling Doctor"
                         id="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         name="CurrentSaveCounsellingPlanRequest.CounsellingDoctor" #Doctor="ngModel"
                         maxlength="100" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Estimated Package Cost</label>
                </div>

                <div class="col-md-5">
                  <input type="number" class="form-control" placeholder="Package Cost"
                         id="CurrentSaveCounsellingPlanRequest.PackageCost"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.PackageCost"
                         name="CurrentSaveCounsellingPlanRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>


                </div>

              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-top-7px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                </div>

                <div class="col-md-5">
                  <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="FNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.FinancialStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.FinancialStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.FinancialStatus">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="PTNT"
                                 id="CurrentSaveCounsellingPlanRequest.Potential"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.Potential" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.Potential">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="PNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.PlanStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.PlanStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.PlanStatus">

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                          </div>

                          <div class="col-md-6 padding-right-0px">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-5px float-right" [disabled]="!f.valid">Save</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Displayfet3()">Back</button>
                </div>

              </div>
            </form>
            <form class="form " novalidate="" (ngSubmit)="onSubmitDem()" #f="ngForm" *ngIf="ShowDemData">
              <div class="card" *ngIf="index1dem">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold">Cycle Details</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 1 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-59px margin-left-0px">

                  <div class="row">


                    <div class="offset-md-1 col-md-5 padding-right-0px">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Cycle Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFTT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-5  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span> Start Date </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">

                    <div class="date-form">
                      <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="dp1" [(ngModel)]="EndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                      <a (click)="d1.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>

                  </div>
                </div>






              </div>
            </div>-->

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4  margin-tg-auto">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Cycle No</label>
                            </div>
                          </div>
                          <div class="row">

                            <div class="col-md-9">
                              <!--<input type="number" class="form-control" placeholder="Cycle No"
                           id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                           [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                           name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                           maxlength="100" />
                    <small class="form-text text-danger"
                           *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>-->
                              <input type="text" class="form-control" placeholder="Cycle No"
                                     id="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo"
                                     [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" required
                                     name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleNo" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                     maxlength="5" />
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && (RecommendedPackage.dirty || RecommendedPackage.touched) && RecommendedPackage.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-10" hidden>
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Menstrual Cycle</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="MENCY"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.MenstrualCycle">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-7  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Culture Info System</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="IVFGM"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.GradingModel" #GradingModel="ngModel" required>
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">

                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-8  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Treatment Protocol</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="TRPRO"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.TreatmentProtocolName">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <!--<div class="row margin-top-10">
              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                <div class="row">
                  <div class="col-md-4  margin-tg-auto ">
                    <label for="diaplayName" class="font-size-12px margin-bottom-0px">
                      <span>*</span>End Date
                    </label>
                  </div>
                </div>
                <div class="row">



                  <div class="col-md-6">
                    <div class="date-form">
                      <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                             name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                      <small class="form-text text-danger"
                             *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>
                  </div>
                </div>


              </div>
            </div>-->
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-6  margin-tg-auto ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px">Infertility Type</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9">
                              <CodeTypeValue CodeType="INFRT"
                                             id="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType"
                                             [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType" SelectedValue=""
                                             name="CurrentSaveIvfTreatmentCyclesInfoRequest.InfertilityType">
                              </CodeTypeValue>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row margin-top-10">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-4 ">
                              <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                            </div>
                          </div>
                          <div class="row">


                            <div class="col-md-9 padding-right-0px">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                        name="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks"
                                        [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.CycleTypeChangeRemarks" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                            </div>

                          </div>

                        </div>
                      </div>

                    </div>

                  </div>



                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-10px" (click)="DisplayDem1()" [disabled]="RecommendedPackage.errors?.required || addconcerns_text.errors?.required ">Continue</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="Back2Dem()">Back</button>
                </div>

              </div>
              <div class="card" *ngIf="index2dem">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px ">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle - </label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> LMP</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 2 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-0px padding-top-0px margin-left-0px padding-right-0px">
                  <div class="chatsd product-chart-wrapper product-chat-width-new-cycle agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                    <div class="row margin-top-10 ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                        <!--<div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 text-align-right ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
                </div>:
                <div class="col-md-5">
                  <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
                </div>
              </div>-->
                        <!--<div class="row">
                <div class="col-md-4 text-align-right margin-top-4px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Egg</label>
                </div>
                <div class="col-md-5">
                  <CodeTypeValue CodeType="IVFEG" id="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"
                                 [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType" SelectedValue=""
                                 name="CurrentSaveIvfTreatmentCyclesInfoRequest.EggSourceType"></CodeTypeValue>
                </div>
              </div>-->
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Select Donor</label>
                          </div>
                          <div class="col-md-5">
                            <!--<input type="text" class="form-control" placeholder="Recommended Package">-->
                            <label class="margin-top-7px" *ngIf="patientName">{{patientName}}</label>

                          </div>
                          <div class="col-md-2 padding-left-0px margin-top-5px">
                            <!--<div class="thick-circle4 nav-link-hand">
                    <a>
                      <i class="fas fa-ellipsis-h"></i>
                    </a>
                  </div>-->
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectDonorForEgg()"> <i class="fas fa-ellipsis-h"></i></button>
                          </div>

                        </div>
                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>LMP</label>
                          </div>
                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="LmpEgg" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>


                        </div>

                        <div class="row margin-top-5px">
                          <div class="col-md-4 text-align-right margin-top-4px">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Remarks</label>
                          </div>
                          <div class="col-md-6">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Remarks"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.LMPCycleRemarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>
                          </div>


                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="DisplayDem2()" [disabled]="DateOfBirth.errors?.required || addconcerns_text.errors?.required ">Continue</button>

                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="DisplayDemstep1()">Back</button>
                </div>

              </div>

              <div class="card" *ngIf="index3dem">
                <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
                  <div class="row">
                    <div class="col-md-9 padding-left-0px">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal margin-right-3px">New Treatment Cycle -</label>
                      <label class="margin-bottom-0px font-size-15px font-weight-bold"> Schedule</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <label class="margin-bottom-0px font-size-15px font-weight-normal">Step 3 of 3</label>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-bottom-26pe  margin-left-0px padding-top-0px">




                  <div class="col-md-12">

                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Branch  :</label>
                </div>


                <div class="col-md-5">
                  <label class="margin-bottom-0px">{{BranchName}}</label>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Choose Treatment Plan</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="CNSPN"
                                 id="CurrentSaveCounsellingPlanRequest.TreatmentPlan"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.TreatmentPlan" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.TreatmentPlan" required>

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Plan</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Treamentplan}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-align-right ">
              <label for="diaplayName" class="font-size-12px margin-bottom-0px margin-top-3px">Treatment Protocol</label>
            </div>:
            <div class="col-md-5">
              <label class=" font-size-12px margin-bottom-0px margin-top-3px">{{Protocol}}</label>
            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Start </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="ProtocolStartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>End  </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp1" [(ngModel)]="ProtocolEndDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                              <a (click)="d1.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Recommended Package</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Recommended Package"
                         id="CurrentSaveCounsellingPlanRequest.RecommendedPackage"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.RecommendedPackage" required
                         name="CurrentSaveCounsellingPlanRequest.RecommendedPackage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                  <small class="form-text text-danger"
                         *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row  ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Primary Doctor</label>
                </div>


                <div class="col-md-5">
                  <input type="text" class="form-control" placeholder="Counselling Doctor"
                         id="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.CounsellingDoctor"
                         name="CurrentSaveCounsellingPlanRequest.CounsellingDoctor" #Doctor="ngModel"
                         maxlength="100" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>

                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Estimated Package Cost</label>
                </div>

                <div class="col-md-5">
                  <input type="number" class="form-control" placeholder="Package Cost"
                         id="CurrentSaveCounsellingPlanRequest.PackageCost"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.PackageCost"
                         name="CurrentSaveCounsellingPlanRequest.PackageCost" pattern="^[0-9]*$" maxlength="40" minlength="1" #Cost="ngModel" required>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && (Cost.dirty || Cost.touched) && Cost.errors.required)">(Field cannot be left blank)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!Cost.valid && Cost.errors.pattern)">(special characters are not allowed)</small>


                </div>

              </div>


            </div>
          </div>-->
                    <!--<div class="row ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-top-7px">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Emi Option</label>
                </div>

                <div class="col-md-5">
                  <input type="checkbox" class="form-control width-14px" id="CurrentSaveCounsellingPlanRequest.SelectEmi"
                         [(ngModel)]="CurrentSaveCounsellingPlanRequest.SelectEmi" name="CurrentSaveCounsellingPlanRequest.SelectEmi">


                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Financial Status</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="FNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.FinancialStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.FinancialStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.FinancialStatus">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto ">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Potential</label>
                </div>

                <div class="col-md-5">
                  <CodeTypeValue CodeType="PTNT"
                                 id="CurrentSaveCounsellingPlanRequest.Potential"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.Potential" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.Potential">
                  </CodeTypeValue>
                </div>
              </div>


            </div>
          </div>-->
                    <!--<div class="row margin-top-10 ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Plan Status</label>
                </div>


                <div class="col-md-5">
                  <CodeTypeValue CodeType="PNSTS"
                                 id="CurrentSaveCounsellingPlanRequest.PlanStatus"
                                 [(ngModel)]="CurrentSaveCounsellingPlanRequest.PlanStatus" SelectedValue=""
                                 name="CurrentSaveCounsellingPlanRequest.PlanStatus">

                  </CodeTypeValue>


                </div>
              </div>


            </div>
          </div>-->

                    <div class="row margin-top-10">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Concerns</label>
                          </div>

                          <div class="col-md-6 padding-right-0px">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Concerns"
                                      name="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks"
                                      [(ngModel)]="CurrentSaveIvfTreatmentCyclesInfoRequest.Remarks" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"></textarea>
                            <small class="form-text text-danger"
                                   *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))"></small>

                          </div>
                        </div>


                      </div>
                    </div>

                  </div>


                </div>
                <div class="card-footer">

                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px float-right" (click)="activeModal.close('Close click')">Cancel</button>
                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-5px float-right" [disabled]="!f.valid">Save</button>
                  <button class="btn font-size-13px actions-btn-prime float-right margin-right-5px" (click)="DisplayDemstep3()">Back</button>
                </div>

              </div>
            </form>

          </div>

        </div>


      </div>
    </div>



    <!--<div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
      <button type="submit" class="btn font-size-13px actions-btn-prime">Save</button>
    </div>-->

  </div>
</div>
